export const prototypeLandmarks = {
  "case_name": "Sample 1",
  "case_id": "3t2UZHYfIxGfpVO6imRV",
  "hip-spine AI version": "v1.3",
  "landmarks": [
    {
      "landmark_name": "sacrum_anterior",
      "x": 0.7904377579689026,
      "y": 0.24410085380077362,
      "likelihood": 0.06833121180534363
    },
    {
      "landmark_name": "sacrum_posterior",
      "x": 0.8148117661476135,
      "y": 0.3113420009613037,
      "likelihood": 0.0044368719682097435
    },
    {
      "landmark_name": "L5_anterior",
      "x": 0.7479127645492554,
      "y": 0.22643285989761353,
      "likelihood": 0.008241839706897736
    }
  ]
}